import React from 'react'

const englishLabels = {
  KEY: 'OUTLOOK KEY',
  OUTLOOK: 'OUTLOOK',
  WATCH: 'WATCH',
  POSITIVE: 'Improving',
  NEGATIVE: 'Deteriorating',
  NEUTRAL: 'Neutral'
}

export default () => {
  const labels = englishLabels
  const textDirection = 'ltr'
  const outlooKeyClass = `ratings-key`

  return (
    <div className={outlooKeyClass}>
      <table
        className="ratings-key__table"
        dir={textDirection}
        style={{ direction: textDirection }}
      >
        <thead>
          <tr>
            <th>{labels.KEY}</th>
            <th>{labels.OUTLOOK}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{labels.POSITIVE}</td>
            <td>
              <span className="ratings-outlook-positive" />
            </td>
          </tr>
          <tr>
            <td>{labels.NEGATIVE}</td>
            <td>
              <span className="ratings-outlook-deteriorating" />
            </td>
          </tr>
          <tr>
            <td>{labels.NEUTRAL}</td>
            <td>
              <span className="ratings-outlook-neutral" />
            </td>
            <td>&nbsp;</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}
